import { v4 as uuidv4 } from "uuid";
import NotificationRuleConditionFields from "./NotificationRuleConditionFields";

export default interface NotificationRuleCondition {
    notificationRuleConditionId?: number;
    notificationRuleId?: number;
    title: string;
    field?: NotificationRuleConditionFields;
    operator?: number;
    value: string;
    tenantId?: number;

    /* Used by v-for when dynamically assigning new Conditions */
    key?: string;
}

export const DefaultNotificationRuleCondition: NotificationRuleCondition = {
    key: uuidv4(),
    title: "",
    value: "",
    field: NotificationRuleConditionFields.Area,
    operator: 0,
    notificationRuleId: null,
    tenantId: null
}